import { Component, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { MatPaginator, MatDialog, MatSort } from '@angular/material';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { generalService } from '../../services/general.service';
import { DataService } from '../../utils/data.service';
import { DataSourceGrid } from '../../utils/data-source-grid.component';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as XLSXStyle from 'xlsx-style';
import { utils } from '../../utils/utils';
import { PdfExporterService } from '../service/pdf-exporter.service';
import { SaleDetails, SaleExportData } from '../../models/sale-export-data';
import { modalComponent } from '../../utils/modal/modal.component';

import { modalConfirmationComponent } from '../../utils/modal/modal-confirmation.component';
import { DatosGeneralesSAE } from '../../datos-generales-SAE';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
import * as $ from 'jquery';
import { ConsultaPagosComponent } from './consulta-de-pagos/consulta-de-pagos.component';

import { DocumentAgregar } from '../../models/document-agregar';
import { Documento } from '../../models/documento';
import { Cliente } from '../../models/cliente';
import { param } from 'jquery';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
    selector: 'my-venta-consultar',
    styleUrls: ['./venta-consultar.component.scss'],
    templateUrl: 'venta-consultar.component.html',
    providers: [generalService, PdfExporterService]
})
export class VentaConsultarComponent {

    // ----------------------------------- DECLARACIÓN DE VARIABLES -----------------------------------
    public userData: any = JSON.parse(sessionStorage.getItem('user'));
    public datosGeneralesSAE: any;

    public filtros: any;
    public lstTipoVenta: any[];
    public CANT_DOCUMENTS: string;
    public TOTAL: string;
    public datosVentas: any[];

    public datosVentasEmpty: any = [
            {id: 1,
        roomCategory: "Single",
        number: 2}
    ];
 

    public rowAEliminar: any;
    public colNum: any = "Núm. Venta";
    public clienteProveedor: any = "";
    public colventaCompra: any = "Núm. Venta";
    public colFecha: any = "Núm. Venta";

    dataSource: DataSourceGrid | null;
    displayedColumns = ['acciones', 'numeroVenta', 'nombreCliente', 'nombrePersonal', 'fechaVenta','fechaCreacion', 'status', 'nombreCreador', 'totalVenta','formaPago','subFamilia'];
    
    public documentExport: any;
    public _utils: utils;
    
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;

    private saleExportName = 'Exportacion Individual';
    public saleExportData: SaleExportData = new SaleExportData();
    public nota: string = 'Nota: Los precios pueden variar al momento de la venta';
    public hasDiscount: any;

    @ViewChild('pdfContainer')
    private pdfContainer: ElementRef;

    @ViewChild('pdfContainerNoPrice')
    private pdfContainerNoPrice: ElementRef;

    @ViewChild('tableVenta') tableVenta: ElementRef;
    @ViewChild('tableVentaDetalle') tableVentaDetalle: ElementRef;

    public venta: Documento = new Documento();
    public PREVIOUS_DEBT = null;
    public isCotizacion: boolean = false;
    public DOCUMENT_ID: string;
    public identificadorCargos: number = 0;
    public identificadorProductos: number = 0;
    public ventaCerrada: boolean = false;
    public IVAPercent: number = 0;
    public viewDataClientes: any[];

    public lstFamilia: any[];
    public lstSubfamilia: any[];
    public lstProducto: any[];
    public listaFormasPago: any[];
    public listaClientes: any[];
    public documentAgregar: DocumentAgregar;
    public parametroUrl:any;
    public webServ:string;
    public nombreCompraVenta:string;
    
    private loacs;

    public containsTaxGeneral = false;
    public mostrarDesgloseIva = false;
    public organizationId = this.userData.ORGANIZATION_ID;

    // ----------------------------------- DECLARACIÓN DE FUNCIONES -----------------------------------

    // ---------------- FUNCIONES DE CARGA ----------------
    constructor(private _generalService: generalService,
                private pdfExporterService: PdfExporterService, 
                public dataService: DataService, 
                public dialog: MatDialog, 
                private ref: ChangeDetectorRef,
                public _activated : ActivatedRoute) {
        this._utils = new utils();
        this.datosVentas = new Array();
        const fechaActual = new Date();

        this._activated.params.forEach((params: Params)=>{
            this.parametroUrl = params['parametro'];
            console.log(this.parametroUrl);
          });

        this.filtros = { 
            START_DATE: new Date(fechaActual.getFullYear(), fechaActual.getMonth(), fechaActual.getDate()), 
            END_DATE: new Date(fechaActual.getFullYear(), fechaActual.getMonth() + 1, 0, 23, 59, 59, 0), 
            TIPO_FECHA: 0,
            DOCUMENT_TYPE_ID: undefined,
            USER_ID: this.userData.USER_ID,
            DOCUMENT_NUMBER: "",
            PERSON_NAME: ""
        };

        this.datosGeneralesSAE = DatosGeneralesSAE;

        this.datosGeneralesSAE.showSpinnerLoading = true;
        this.getDocumentsTypes();
        this.organizationDiscount();

    }

    ngOnInit() {
        this.loacs = sessionStorage.getItem("acslo");

        this.consultarParametros();
    }

    consultarParametros() {
        this.consultarParamProdSinIVA();
        this.consultarParamNotaDesgloseIVA();
    }

    consultarParamProdSinIVA() {
        this._generalService.metodoCallParams(this.loacs, 'itemLookUp/consultIVA')
            .subscribe(itemIVA => {
                itemIVA = JSON.parse(itemIVA);
                this.containsTaxGeneral = (itemIVA.length > 0);
            }, error => {
                // Custom error handler
            });
    }

    consultarParamNotaDesgloseIVA() {
        var params: any = {};
        params.Name = 'NOTA_IVA_DESGLOSE';
        params.organizationId = this.userData.ORGANIZATION_ID;

        var paramsJSON: string = JSON.stringify(params);

        this._generalService.requestPostParams(params, 'itemLookUp/consultOrganizationLookupByName')
            .subscribe(item => {
                item = JSON.parse(item);
                this.mostrarDesgloseIva = (item.length > 0 && item[0].VALUE == "1");
            }, error => {
                // Custom error handler
            });
    }

    getDocumentsTypes() {
        this._generalService.requestGet('venta/GetDocumentsTypes').subscribe(
            (result) => {
                this.lstTipoVenta = JSON.parse(result);
                this.getDocuments();
            },
            (error) => {
                const errorMsj =  error as any;
                console.error(errorMsj);
            }
        );
    }

    getDocuments() {
        var paramsJSON: string = JSON.stringify(this.filtros);
        this.parametroUrl == ':parametro' ? this.webServ = 'venta/GetDocumentsCompras?parametros=' : this.webServ = 'venta/GetDocuments?parametros=';
        this._generalService.requestGet(this.webServ + paramsJSON).subscribe(
            (result) => {
                const tableResult = JSON.parse(result);
                this.datosVentas = tableResult.Table;
                if (this.datosVentas.length > 0) {
                    if (this.datosVentas[0].DOCUMENT_ID === null) {
                        this.datosVentas = new Array();
                        this.CANT_DOCUMENTS = undefined;
                        this.TOTAL = undefined;
                    } 
                    else {
                        this.CANT_DOCUMENTS = tableResult.Table1[0].CANT_DOCUMENTS;
                        this.TOTAL = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(tableResult.Table1[0].TOTAL);
                    }
                } 
                else {
                    this.CANT_DOCUMENTS = undefined;
                    this.TOTAL = undefined;
                }
                this.dataSource = new DataSourceGrid(this.datosVentas, this.paginator, this.sort);
                if (this.datosVentas.length <= 0) {
                    $('.mat-row').remove('.mat-row');
                }
                this.datosGeneralesSAE.showSpinnerLoading = false;
            },
            (error) => {
                console.log(error as any);
            }
        );
    }


    // -------------- FUNCIONES DE ACCIONES ---------------
    confirmarEliminacionOSalidaVenta(row: any, SalidaOEliminar: number ){
        // 0 para Salida, 1 para Eliminar Venta
        this.rowAEliminar = row;

        this.parametroUrl == ':parametro' ? this.nombreCompraVenta = "compra:" : this.nombreCompraVenta = "venta:"

        if(SalidaOEliminar == 1)
        {
            const dialogRef = this.dialog.open(modalConfirmationComponent, {
                disableClose: true,
                data: {
                    mensaje: '¿Desea eliminar la '+ this.nombreCompraVenta + row.DOCUMENT_NUMBER + '?',
             }
            });

            dialogRef.afterClosed().subscribe(
                (result) => {
                    if(result == 1){
                        this.datosGeneralesSAE.showSpinnerLoading = true;
                        this.eliminarVenta(SalidaOEliminar);
                    }
                }
            );
        }
        if(SalidaOEliminar == 0)
        {
            const dialogRef = this.dialog.open(modalConfirmationComponent, {
                disableClose: true,
                data: {
                    mensaje: '¿Desea generar la salida de Almacén de la '+ this.nombreCompraVenta + row.DOCUMENT_NUMBER + '?',
             }
            });

            dialogRef.afterClosed().subscribe(
                (result) => {
                    if(result == 1){
                        this.datosGeneralesSAE.showSpinnerLoading = true;
                        this.eliminarVenta(SalidaOEliminar);
                    }
                }
            );
        }
    }

    eliminarVenta(SalidaOEliminar: number ){
        // 0 para Salida, 1 para Eliminar Venta
        this.datosGeneralesSAE.showSpinnerLoading = true;

        /* Traer información de Venta (deuda)*/
        this.cargarInformacionVenta(SalidaOEliminar);

        let params: any = {
            USER_ID: this.userData.USER_ID,
            DOCUMENT_TYPE_ID: this.rowAEliminar.DOCUMENT_TYPE_ID,
            DOCUMENT_ID: this.rowAEliminar.DOCUMENT_ID,
            CLIENT_ID: this.rowAEliminar.CLIENT_ID
        }
        var paramsJSON: string = JSON.stringify(params);
        if(SalidaOEliminar == 1)
        {
            this._generalService.requestPut("venta/DeleteDocument?parametros=" + paramsJSON).subscribe(
                result => {
                    this.getDocuments();
                },
                error => {
                    var errorMsj = <any>error;
                    console.log(errorMsj);
                }
            );
        }
    }

    cargarInformacionVenta(SalidaOEliminar: number): Promise<void> {
        // 0 para Salida, 1 para Eliminar Venta
        return new Promise((resolve, reject) => {
                this._generalService.requestGet("venta/cargarInformacionVisualizarVenta?idUsuario=" + this.userData.USER_ID + "&idDocumento=" + this.rowAEliminar.DOCUMENT_ID).subscribe(
                    (result) => {
                        var dataTemp: any = JSON.parse(result);

                        // Venta
                        this.venta = dataTemp.Table7[0];
                        if(this.venta.cliente === undefined || this.venta.cliente === null){
                            this.venta.cliente = new Cliente();
                        }
                        
                        if(this.venta.DOCUMENT_TYPE_ID === 3) {
                            if (this.dataService.acceso) {
                                this.DOCUMENT_ID = 'N';
                                this.venta.DOCUMENT_ID = null;
                                this.venta.DOCUMENT_NUMBER = null;
                                this.venta.DOCUMENT_TYPE_ID = null;
                                this.venta.ESTATUS = '';
                                this.lstTipoVenta.splice(2,1);
                            } 
                        }

                        this.venta.Productos = dataTemp.Table8;

                        if(this.venta.DEBT !== undefined && this.venta.DEBT !== null) { // Tiene deuda 
                            this.PREVIOUS_DEBT = this.venta.DEBT;
                        }
                        this.datosGeneralesSAE.showSpinnerLoading = false;//Estaba comentado
                        resolve();
                        if(this.venta.cliente != null){
                            this.actualizarDeudaCliente(SalidaOEliminar);
                        }
                    },
                    (error) => {
                        const errorMsj =  error as any;
                        console.error(errorMsj);
                        reject();
                    }
                );
        });

    }

    actualizarDeudaCliente(SalidaOEliminar: number) {
        this.datosGeneralesSAE.showSpinnerLoading = true;
        // Se obtienen los parámetros que se enviarán a la función que guarda la venta
        this.documentAgregar = this.obtenerDocumentCancelar();
        if(SalidaOEliminar == 1)
        {
            this._generalService.requestPostParams(this.documentAgregar, 'venta/CancelarVentaActualizarDeudaCliente/').subscribe(
                (result) => {
                    if (result !== 'La venta se canceló correctamente') {
                        this.datosGeneralesSAE.showSpinnerLoading = false;
                        this.modal('alert', result);
                    } 
                    else {
                   
                            this.datosGeneralesSAE.showSpinnerLoading = false;
                    }
                },
                (error) => {
                    console.error(error as any);
                }
            );
        }
        else if (SalidaOEliminar == 0)
        {
            this._generalService.requestPostParams(this.documentAgregar, 'venta/SalidaDocument/').subscribe(
                result => {
                    this.getDocuments();
                    this._generalService.toastCall(result);
                },
                error => {
                    var errorMsj = <any>error;
                    console.log(errorMsj);
                }
            );
        }
    }

    obtenerDocumentCancelar(): DocumentAgregar {
        let status = 'cerrada';
        if (this.venta.DOCUMENT_TYPE_ID !== 3) {
            status = 'deuda pendiente';
            if (this.venta.CUSTOMER_SUPPLIER_ID > 0) {
                this.venta.DEBT = this.venta.TOTAL;
            }
        }

        if (this.venta.cliente) {
            this.venta.cliente.Nombre = this.venta.cliente.razonSocial;
        }
        
        this.venta.PREVIOUS_DEBT = (this.PREVIOUS_DEBT !== null && this.PREVIOUS_DEBT !== undefined) ? this.PREVIOUS_DEBT : 0;

        this.documentAgregar = {
            Venta: Object.assign({}, this.venta),
            Productos: this.venta.Productos.map(x => Object.assign({}, x)),
            Cargos: null,
            NOMENCLATURA: this.isCotizacion ? 'CO' : 'VN',
            USER_ID: this.userData.USER_ID,
            ORGANIZATION_ID: this.userData.ORGANIZATION_ID,
            STATUS: status,
            CUSTOMER_ADDRESS_ID: this.venta.CUSTOMER_ADDRESS_ID,
            CUSTOMER_SUPPLIER_CONTACT_ID :this.venta.CUSTOMER_SUPPLIER_CONTACT_ID
        };

        return this.documentAgregar;
    }


    exportPDF(documentId: any, showPrice:boolean) {
        this.datosGeneralesSAE.showSpinnerLoading = true;

        this._generalService.requestGet("venta/getSaleExportData?documentId=" + documentId).subscribe(
            (saleExporDataSet) => {
                saleExporDataSet = JSON.parse(saleExporDataSet);
                this.saleExportData = this.generateSaleExportDataFromDataSet(saleExporDataSet);
                this.saleExportData.hasDiscount = this.hasDiscount;

                if (!this.containsTaxGeneral) {
                    // Validar parametro que indica si se mostrara el total con o sin desglose de iva
                    if (this.mostrarDesgloseIva) {
                        this.saleExportData.subtotal = this.saleExportData.subtotal - this.saleExportData.IVA
                    }
                }

                if(this.saleExportData.saleTypeId === 3){
                    this.saleExportData.tipoVenta = "COTIZACIÓN";
                    this.saleExportData.note = this.nota;
                }else if(this.parametroUrl == ':parametro'){
                    this.saleExportName = 'Compra ' + this.saleExportData.saleNumber;
                }
                else {
                    this.saleExportData.tipoVenta = "VENTA"; }
                setTimeout(() => {
                    this.datosGeneralesSAE.showSpinnerLoading = false;
                    if(this.saleExportData.saleTypeId === 3){
                        this.saleExportName = 'Cotización ' + this.saleExportData.saleNumber;
                    }
                    else if(this.parametroUrl == ':parametro'){
                        this.saleExportName = 'Compra ' + this.saleExportData.saleNumber;
                    } else {
                        this.saleExportName = 'Venta ' + this.saleExportData.saleNumber; 
                    }
                    if (showPrice === true){
                        // this.pdfExporterService.export(this.pdfContainer, this.saleExportName);
                        this.pdfExporterService.export(this.saleExportData, this.saleExportName,showPrice);
                    }else{
                        // this.pdfExporterService.export(this.pdfContainerNoPrice, this.saleExportName);
                        this.pdfExporterService.export(this.saleExportData, this.saleExportName,showPrice);
                    }
                }, 300);
            }, 
            (error) => {
                console.error(error);
            }
        );
    }

    exportarExcel() {
        if (this.datosVentas.length > 0) {
            this.getDocumentsExport();
        }
    }

    // ---------- FUNCIONES DE EXPORTACIÓN PDF ------------
    private generateSaleExportDataFromDataSet(saleExporDataSet): SaleExportData {
        let saleExportData = new SaleExportData();
        saleExportData = saleExporDataSet.Table[0];
        saleExportData.details =  saleExporDataSet.Table1;

        if(saleExporDataSet.Table2.length == 0){
            saleExportData.defaultComment = '';
        } else {
            saleExportData.defaultComment = saleExporDataSet.Table2[0].defaultComment;
        }

        // var numRenglones = saleExportData.details.length;

        // const objeto = saleExportData.details[0]

        // for(let i = 0; i<70; i++){
        //     saleExportData.details.push(objeto);
        // }

        // var numRenglones = saleExportData.details.length;

        // if(numRenglones > 17 && numRenglones < 29){
        //     for(var i=numRenglones; i <= 35; i++){
        //         let x = new SaleDetails();
        //         saleExportData.details.push(x);
        //     }
        // }
        // else if(numRenglones >= 29){
        //     for(var i=0; i < 7; i++){
        //         let x = new SaleDetails();
        //         saleExportData.details.splice(28, 0, x);
        //     }
        //     if(numRenglones > 57 && numRenglones < 71){
        //         for(var i=numRenglones; i <= 77; i++){
        //             let x = new SaleDetails();
        //             saleExportData.details.push(x);
        //         }    
        //     }
        //     else if(numRenglones >= 71){
        //         for(var i=0; i < 7; i++){
        //             let x = new SaleDetails();
        //             saleExportData.details.splice(70, 0, x);
        //         }
        //     }
        // }
        

        return saleExportData;
    }

    // ---------- FUNCIONES DE EXPORTACIÓN EXCEL ----------
    getDocumentsExport() {
        this.datosGeneralesSAE.showSpinnerLoading = true;

        console.log(this.filtros);

        var paramsJSON: string = JSON.stringify(this.filtros);
        this.parametroUrl == ':parametro' ? this.webServ = 'venta/GetDocumentsExportCompras?parametros=':this.webServ = 'venta/GetDocumentsExport?parametros=';

        this._generalService.requestGet(this.webServ + paramsJSON).subscribe(
            (result) => {
                this.documentExport = new Array();
               

                const tableResult = JSON.parse(result);
                

                const datosVentaExportar = tableResult.Table;
                const datosItemsExportar = tableResult.Table1;
                const datosCargosExportar = tableResult.Table2;

                for (let i = 0; i < datosVentaExportar.length; i++) {
                    datosVentaExportar[i].items = datosItemsExportar.filter((obj: any) => {
                        return obj.DOCUMENT_ID === datosVentaExportar[i].DOCUMENT_ID;
                    });
                    datosVentaExportar[i].cargos = datosCargosExportar.filter((obj: any) => {
                        return obj.DOCUMENT_ID === datosVentaExportar[i].DOCUMENT_ID;
                    });
                }
                this.documentExport = datosVentaExportar;

                setTimeout(() => {
                    this.readyExport();
                }, 300);
            },
            (error) => {
                console.log(error as any);
            }
        );
    }

    readyExport() {
        const fechaInicio = this._utils.convertDate(new Date(this.filtros.START_DATE), 'yyyy-mm-dd');
        const fechaFin = this._utils.convertDate(new Date(this.filtros.END_DATE), 'yyyy-mm-dd');
        let tituloExcel = ""
        if(this.parametroUrl == ':parametro'){
            tituloExcel= 'Reporte de Compra ';
            this.colNum = 'Núm. Compra';
            this.colFecha = 'Fecha de Compra';
            this.clienteProveedor = 'Proveedor'
        }else{
            tituloExcel= 'Reporte de Ventas ';
            this.colNum = 'Núm. Venta';
            this.colFecha = 'Fecha de Venta';
            this.clienteProveedor = 'Cliente'
        }
        setTimeout(() => this.exportAsExcelFile(tituloExcel + fechaInicio + ' - ' + fechaFin), 300);
    }

    public exportAsExcelFile(filename: string): void {
        
        const worksheet: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.tableVenta.nativeElement);
        const worksheetDetalle: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.tableVentaDetalle.nativeElement);
        var tituloCol01 = "", 
            tituloCol02 = "",
            tituloCol03 = "";
        this.parametroUrl == ':parametro' ? tituloCol01 = 'Reporte de Compra' : tituloCol01 = 'Reporte de Ventas';
        this.parametroUrl == ':parametro' ? tituloCol02 = 'Fecha de Compra' : tituloCol02 = 'Fecha de Venta';
        this.parametroUrl == ':parametro' ? tituloCol03 = 'Proveedor' : tituloCol02 = 'Cliente';

       const headersWorksheet = [tituloCol01,tituloCol03, 'Solicitante', tituloCol02, 'Estatus', 'Tipo', 'Creado por','Fecha de Creación',  'Entrega', 'Dirección', 'Fecha Compromiso Entrega', 'Total $','Forma de Pago','Sub Familia', 'Costo $', 'Utilidad $', 'Utilidad %', 'Observaciones'];
        const headers = ['Costo $', 'Utilidad $', 'Utilidad %', 'Cargo', 'Producto', 'Cantidad', 'Total $', tituloCol01, tituloCol03, 'Solicitante', tituloCol02, 'Estatus', 'Tipo', 'Entrega', 'Dirección', 'Fecha Compromiso Entrega'];
        for (const z in worksheet) {
            if (z[0] === '!') { 
                continue; 
            }
            if (worksheet[z]) {                
                if (headersWorksheet.indexOf(worksheet[z].v + '') > -1) {
                    this.wrapAndCenterCell(worksheet[z], 'header');
                } else if (z.indexOf('L') > -1 || z.indexOf('O') > -1 || z.indexOf('P') > -1) {
                    this.wrapAndCenterCell(worksheet[z], 'decimal');
                } else if (z.indexOf('Q') > -1) {
                    this.wrapAndCenterCell(worksheet[z], 'porcentaje');
                } else if (((z + '').indexOf('D') > -1 || z.indexOf('H') > -1 || z.indexOf('K') > -1) && worksheet[z].t === 'n' && worksheet[z].z !== 'm/d/yy') {
                    this.wrapAndCenterCell(worksheet[z], 'decimal');
                }
            }
        }

        for (const z in worksheetDetalle) {
            if (z[0] === '!') { 
                continue;
            }
            if (worksheetDetalle[z]) {
                if (headers.indexOf(worksheetDetalle[z].v + '') > -1) {
                    this.wrapAndCenterCell(worksheetDetalle[z], 'header');
                } else if (z.indexOf('K') > -1 || z.indexOf('L') > -1) {
                    this.wrapAndCenterCell(worksheetDetalle[z], 'decimal');
                } else if (z.indexOf('M') > -1 || z.indexOf('G') > -1) {
                    this.wrapAndCenterCell(worksheetDetalle[z], 'porcentaje');
                } else if (((z + '').indexOf('J') > -1 || (z + '').indexOf('D') > -1 || z.indexOf('E') > -1 || z.indexOf('F') > -1) && worksheetDetalle[z].t === 'n' && worksheetDetalle[z].z !== 'm/d/yy') {
                    this.wrapAndCenterCell(worksheetDetalle[z], 'decimal');
                }
            }
        }

        const workbook: XLSX.WorkBook = { Sheets: { General: worksheet, Detallado: worksheetDetalle }, SheetNames: ['General', 'Detallado'] };
        const excelBuffer: any = XLSXStyle.write(workbook, { bookType: 'xlsx', type: 'buffer' });

        this.datosGeneralesSAE.showSpinnerLoading = false;
        this.saveAsExcelFile(excelBuffer, filename);
    }

    private wrapAndCenterCell(cell: XLSX.CellObject, tipo: any) {
        let cellStyle;
        switch (tipo) {
            case 'header': {
                cellStyle = { font: {bold: true} };
                break;
            }
            case 'numerico': {
                cellStyle = { numFmt: '0' };
                break;
            }
            case 'decimal': {
                cellStyle = { numFmt: '$0.00;\\($0.00\\);\\-;@' };
                break;
            }
            case 'porcentaje': {
                cellStyle = { numFmt: '0.00%;\\(0.00%\\);\\-;@' };
                break;
            }
        }
        this.setCellStyle(cell, cellStyle);
    }

    private setCellStyle(cell: XLSX.CellObject, style: {}) {

        cell.s = style;
    }

    private saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    }

    // -------------- FUNCIONES SECUNDARIAS ---------------
    modal(tipo: string, mensaje: string) {
        this.dataService.modal = tipo;
        this.dataService.mensaje = mensaje;
        const dialogModal = this.dialog.open(modalComponent, {disableClose: true});
        this.dataService.dialogModal = dialogModal;
    }

    // --------------- FUNCION DE CARGA -------------------
    organizationDiscount() {
        let idSucursal:number = this.userData.ORGANIZATION_ID;
        let webService = 'venta/organizationDiscount?idSucursal=' + idSucursal;
        this._generalService
          .metodoCall(webService, true)
          .subscribe(result => {
            let newArray = result;
            this.hasDiscount = newArray[0].hasDiscount;

            },
          error => {  console.log(<any>error);  }
        );
      }


    consultaPagos(venta) {
        this.dataService.id = venta.DOCUMENT_ID;
        this.dataService.mensaje = venta.DOCUMENT_NUMBER;
        const dialogRef = this.dialog.open(ConsultaPagosComponent, {disableClose: true, width:'100%', maxWidth:'70%', panelClass: 'full-width-dialog'});
        this.dataService.dialogRef = dialogRef;
        dialogRef.afterClosed().subscribe((result) => {
            //if(this.dataService.acceso == 0){
            //    this._generalService.toastCall("La venta "+ venta.DOCUMENT_NUMBER +" no tiene pagos registrados");
            //    this.dataService.acceso = null;
            //  } 
            this.getDocuments()
        });
      }

      searchFilter() {
        if(this.datosVentas.length <= 0) {
          this.dataSource = undefined;
        } 
        else 
        {
          let filtroVentas = this.datosVentas;
          if(this.filtros.DOCUMENT_NUMBER != "" && this.filtros.PERSON_NAME != "") {
            filtroVentas = this.datosVentas.filter((obj: any) => {            
              if (obj.DOCUMENT_NUMBER.toLowerCase().indexOf(this.filtros.DOCUMENT_NUMBER.toLowerCase()) != -1 && obj.PERSON_NAME.toLowerCase().indexOf(this.filtros.PERSON_NAME.toLowerCase())  != -1)
                  return true;
              else
                  return false;
            });
          }
          else if(this.filtros.DOCUMENT_NUMBER != "") {
            filtroVentas = this.datosVentas.filter((obj: any) => {            
              if (obj.DOCUMENT_NUMBER.toLowerCase().indexOf(this.filtros.DOCUMENT_NUMBER.toLowerCase()) != -1)
                  return true;
              else
                  return false;
            });
          }
          else if(this.filtros.PERSON_NAME != "") {
            filtroVentas = this.datosVentas.filter((obj: any) => {            
              if (obj.PERSON_NAME.toLowerCase().indexOf(this.filtros.PERSON_NAME.toLowerCase()) != -1)
                  return true;
              else
                  return false;
            });
          }
          
          if(filtroVentas.length > 0)
          {
              this.dataSource = new DataSourceGrid(filtroVentas, this.paginator, this.sort);
          }
          else{
              this.dataSource = new DataSourceGrid(this.datosVentasEmpty, this.paginator, this.sort);
          }
            //filtroVentas = this.datosVentas;
            //this.dataSource = new DataSourceGrid(this.datosVentas, this.paginator, this.sort);
        }
      }

      accesoEditar(acceso: boolean, idSalida, numRegistros){
          this.dataService.acceso = acceso;

          if (idSalida !== 0 || numRegistros !== 0) {
              this.dataService.ventaEditable = true;
          } else {
            this.dataService.ventaEditable = false;
          }
      }

      crearTicketPago(idCotizacion: any){
    console.log(this.organizationId, idCotizacion);
    this.datosGeneralesSAE.showSpinnerLoading = true;
    var bandera = false;
    // Se consulta la información y configuración del ticket en base al pago y sucursal
    this._generalService.requestGet("pago/crearTicketCotizacion?idOrganization=" + this.organizationId + "&idCotizacion=" + idCotizacion + "&bandera=" + bandera).subscribe(
        (result) => {

            // El primer paso para imprimir el ticket es transformar la base64 a un arreglo de bytes con el cual se obtendrá un 
            // objeto blob
            const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
                const byteCharacters = atob(b64Data);
                const byteArrays = [];
                for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    const slice = byteCharacters.slice(offset, offset + sliceSize);
                    const byteNumbers = new Array(slice.length);
                    for (let i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    byteArrays.push(byteArray);
                }
                const blob = new Blob(byteArrays, {type: contentType});
                return blob;
            }
            const blob = b64toBlob(result, "application/pdf");

            // Se crea una url valida con el objeto blob
            const blobUrl = URL.createObjectURL(blob);

            // Se elimina el iframe del ticket si ya había sido creado uno
            if (document.getElementById("iframeTicketII") != null){
                $("#iframeTicketII").remove();
            }

            // Se crea un iframe para el ticket y se le pone como src el url creado apartir del blob
            var iframe: any = document.createElement('iframe');
            iframe.id = "iframeTicketII";
            iframe.style.display = 'none';
            iframe.src = blobUrl;
            document.body.appendChild(iframe);

            // Se pone en un timeout en lo que se espera a que se agrege al body del document y se pueda imprimir
            setTimeout(()=>{    
                // Se imprime el ticket
                iframe.focus();
                iframe.contentWindow.print();

                this.datosGeneralesSAE.showSpinnerLoading = false;
           }, 100);

        },
        (error) => {
            const errorMsj =  error as any;
            console.error(errorMsj);
        }
    );

  }

}


// WEBPACK FOOTER //
// ./src/app/venta/consultar/venta-consultar.component.ts